// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Z2YY","title":"styles_title__2-ppY","input":"styles_input__oBWff","newTeam":"styles_newTeam__3Msh7"};